// Po odscrollovaní pridá hlavičke .is-scrolled (zvýraznené pozadie, menšie logo)
const SCROLL_THRESHOLD = 40

function initHeaderScroll() {
    const header = document.querySelector( ".main-header" )

    if ( !header ) return

    let ticking = false

    function update() {
        header.classList.toggle( "is-scrolled", window.scrollY > SCROLL_THRESHOLD )
        ticking = false
    }

    window.addEventListener( "scroll", function() {
        if ( !ticking ) {
            window.requestAnimationFrame( update )
            ticking = true
        }
    }, { passive: true })

    update()
}

$(document).ready( function() {
    initHeaderScroll()
})
